import React from "react";

const Contacts=()=>{
    return  <h1>Contact Page</h1>
   
}
export default Contacts;